import React from "react";
import {v4 as uuid} from "uuid";
import {useSelector} from "react-redux";
import {getHistory} from "../../../store/slices/productFinder";

const BackButton = (props) => {

    const {
        onClick
    } = props;

    const history = useSelector(getHistory);

    if(!history || !Array.isArray(history) || history.length < 2) {
        return null;
    }

    const _onClick = () => {

        const previousPage = history[history.length-2];
        onClick(previousPage, history);
    }

    return (
        <div
            key={uuid()}
            className="product-finder-back-button"
        >
            <button className="swiper-button-prev animate back-btn-in animation-delay-10" onClick={_onClick} />
        </div>
    )

}

export default BackButton;
